export const LEGACY_LOCATION_BARCODE_CONFIG = {
  width: 1.5,
  height: 64,
  margin: 1,
  marginLeft: 5,
  marginRight: 5,
  marginBottom: 0.2,
  displayValue: false,
  format: 'CODE128',
}

export const PALLET_BARCODE_CONFIG = {
  width: 2.6,
  height: 180,
  margin: 1,
  marginLeft: 5,
  marginRight: 5,
  marginBottom: 0.2,
  displayValue: false,
  format: 'CODE128',
}

export const PALLET_LG_BARCODE_CONFIG = {
  width: 2.4,
  height: 160,
  margin: 0.6,
  marginLeft: 3,
  marginRight: 3,
  marginBottom: 0.2,
  displayValue: false,
  format: 'CODE128',
}

export const STACKABLE_XL_BARCODE_CONFIG = {
  width: 2.6,
  height: 180,
  margin: 1,
  marginLeft: 5,
  marginRight: 5,
  marginBottom: 0.2,
  displayValue: false,
  format: 'CODE128',
}

export const STACKABLE_LG_BARCODE_CONFIG = {
  width: 2.4,
  height: 160,
  margin: 0.6,
  marginLeft: 3,
  marginRight: 3,
  marginBottom: 0.2,
  displayValue: false,
  format: 'CODE128',
}

export const SHELF_BARCODE_CONFIG = {
  width: 1.2,
  height: 36,
  margin: 0.6,
  marginLeft: 3,
  marginRight: 3,
  marginBottom: 0.2,
  displayValue: false,
  format: 'CODE128',
}

export const BIN_LG_BARCODE_CONFIG = {
  width: 3.0,
  height: 160,
  margin: 0.6,
  marginLeft: 3,
  marginRight: 3,
  marginBottom: 0.2,
  displayValue: false,
  format: 'CODE128',
}

export const BIN_SM_BARCODE_CONFIG = {
  width: 1.2,
  maxBarsWidth: 248, // 288px label minus 20px each side
  height: 70,
  margin: 0,
  displayValue: false,
  format: 'CODE128',
}

export const DEFAULT_BARCODE_CONFIG = {
  width: 1.5,
  maxBarsWidth: 248, // 288px label minus 20px each side
  height: 80,
  margin: 0,
  displayValue: false,
  format: 'CODE128',
}

export const INITIAL_LOCATIONS_SEARCH_PARAMS = {
  warehouse_id: '',
  id: '',
  name_like: '',
  location_category_id: '',
  movable: '',
  permanent: '',
  ambient: '',
  cold_chain: '',
  restricted_access: '',
  controlled: '',
  hazmat: '',
  restricted_pharma: '',
  restricted_ecomm: '',
  restricted_precursor: '',
  sort_method: 'desc',
  order_by: 'id',
  limit: 15,
  page: 1,
}
